export interface VideoItem {
  id: string;
  slug: string;
  title: string;
  description: string;
  thumbnail: string;
  videoUrl: string;
  category: string;
  tags: string[];
  publishedAt: string;
  duration: string;
  views: string;
  featured: boolean;
}

export const videos: VideoItem[] = [
  {
    id: "1",
    slug: "ltv-launch-ceremony",
    title: "L+TV TÉLÉVISION Launch Ceremony — Full Coverage",
    description: "Watch the full coverage of the L+TV digital platform launch ceremony held in Edea, featuring speeches, performances, and special announcements.",
    thumbnail: "https://readdy.ai/api/search-image?query=Television%20channel%20launch%20event%20stage%20with%20red%20and%20blue%20branding%2C%20professional%20event%20photography%2C%20warm%20lighting%2C%20editorial%20style&width=640&height=360&seq=video-1&orientation=landscape",
    videoUrl: "",
    category: "News",
    tags: ["L+TV", "launch", "event"],
    publishedAt: "2026-08-25",
    duration: "12:45",
    views: "8,420",
    featured: true,
  },
  {
    id: "2",
    slug: "edea-infrastructure-report",
    title: "Edea 2026 Infrastructure Development Report",
    description: "A comprehensive report on the planned infrastructure projects for Edea in 2026, including interviews with officials and community perspectives.",
    thumbnail: "https://readdy.ai/api/search-image?query=Urban%20infrastructure%20development%20aerial%20view%2C%20roads%20and%20buildings%2C%20African%20city%20development%2C%20editorial%20photography%20style&width=640&height=360&seq=video-2&orientation=landscape",
    videoUrl: "",
    category: "Reports",
    tags: ["Edea", "infrastructure", "report"],
    publishedAt: "2026-08-24",
    duration: "08:30",
    views: "5,210",
    featured: false,
  },
  {
    id: "3",
    slug: "indomitable-lions-training",
    title: "Inside the Indomitable Lions Training Camp",
    description: "Exclusive behind-the-scenes footage from the Cameroon national football team training camp ahead of their qualifier match.",
    thumbnail: "https://readdy.ai/api/search-image?query=Football%20team%20training%20on%20professional%20pitch%2C%20players%20in%20drills%2C%20warm%20sunlight%2C%20sports%20photography%20style&width=640&height=360&seq=video-3&orientation=landscape",
    videoUrl: "",
    category: "Sports",
    tags: ["football", "Cameroon", "training"],
    publishedAt: "2026-08-23",
    duration: "06:15",
    views: "12,800",
    featured: true,
  },
  {
    id: "4",
    slug: "technology-summit-highlights",
    title: "Technology Summit Douala — Highlights & Key Moments",
    description: "Key highlights from the technology summit in Douala, featuring presentations from leading innovators and startups.",
    thumbnail: "https://readdy.ai/api/search-image?query=Technology%20conference%20speaker%20on%20stage%20with%20presentation%20screen%2C%20professional%20event%20photography%2C%20warm%20lighting%2C%20editorial%20style&width=640&height=360&seq=video-4&orientation=landscape",
    videoUrl: "",
    category: "Technology",
    tags: ["technology", "Douala", "summit"],
    publishedAt: "2026-08-22",
    duration: "10:20",
    views: "4,150",
    featured: false,
  },
  {
    id: "5",
    slug: "ltv-music-showcase",
    title: "L+TV Music Showcase — Rising Stars from Cameroon",
    description: "A special music program featuring performances from emerging Cameroonian artists representing diverse genres and regions.",
    thumbnail: "https://readdy.ai/api/search-image?query=Musician%20performing%20on%20stage%20with%20colorful%20lighting%2C%20live%20music%20event%2C%20African%20artist%20performance%2C%20editorial%20photography%20style&width=640&height=360&seq=video-5&orientation=landscape",
    videoUrl: "",
    category: "Entertainment",
    tags: ["music", "Cameroon", "entertainment"],
    publishedAt: "2026-08-21",
    duration: "15:00",
    views: "9,600",
    featured: true,
  },
  {
    id: "6",
    slug: "ltv-cultural-heritage",
    title: "Cultural Heritage of Edea and the Littoral Region",
    description: "A documentary exploring the rich cultural heritage, traditions, and history of Edea and the broader Littoral Region of Cameroon.",
    thumbnail: "https://readdy.ai/api/search-image?query=Traditional%20African%20cultural%20dance%20performance%20with%20colorful%20costumes%2C%20village%20setting%2C%20warm%20sunlight%2C%20documentary%20photography%20style&width=640&height=360&seq=video-6&orientation=landscape",
    videoUrl: "",
    category: "Culture",
    tags: ["culture", "Edea", "documentary"],
    publishedAt: "2026-08-20",
    duration: "22:30",
    views: "6,750",
    featured: false,
  },
];